import type { HttpRequest } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { BaseJwtInterceptor } from '@common/interceptors/base-jwt.interceptor';
import { RedirectFacade } from '@common/utils/redirect/redirect.facade';

import { AppFacade } from '@web/store/app/app.facade';

import { environment } from '@web-env/environment';
import { EEnvTypes } from '@common/enums/env-types.enum';

@Injectable()
export class JwtInterceptor extends BaseJwtInterceptor {
    private readonly cookieService = inject(CookieService);
    private readonly redirectFacade = inject(RedirectFacade);
    private readonly appFacade = inject(AppFacade);

    protected readonly isDev: boolean = environment.type === EEnvTypes.DEV;
    protected isAdmin: boolean = false;

    constructor() {
        super();
        this.appFacade.isAdmin$.subscribe((isAdmin: boolean) => {
            this.isAdmin = isAdmin;
        });
    }

    protected getToken(request: HttpRequest<unknown>): string {
        let token = this.adminAccessToken;

        if (!this.isAdmin || request.url.includes('api/file-manager')) {
            token = this.accessToken;
        }

        return this.cookieService.get(token);
    }

    protected unauthorizedAction(): void {
        if (environment.type === EEnvTypes.PREVIEW) {
            return;
        }
        this.redirectFacade.redirectAction('/');
    }
}
